:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._container_1owke_7 {
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  box-sizing: border-box;
  margin-left: 8px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center; }
  ._container_1owke_7::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    box-sizing: border-box;
    border-radius: 50%;
    box-shadow: 0px 5px 7px -4px rgba(23, 25, 28, 0.16) inset;
    border: 1px solid #dfe5eb; }

._empty-state_1owke_30 {
  background-color: #ffffff;
  background-image: linear-gradient(45deg, #d5d5d5 26%, transparent 26%, transparent 74%, #d5d5d5 74%, #d5d5d5), linear-gradient(45deg, #d5d5d5 26%, transparent 26%, transparent 74%, #d5d5d5 74%, #d5d5d5);
  opacity: 0.4;
  background-size: 8px 8px;
  background-position: 0 0, 4px 4px; }

._fill-layer_1owke_37,
._media-container_1owke_38,
._empty-state_1owke_30 {
  position: absolute;
  width: 19px;
  height: 19px;
  border-radius: 50%;
  box-sizing: border-box; }
